import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

//Redux

import * as sessionActions from "../../redux/rides/actions";
import * as sessionActionss from "../../redux/user/actions";

//Components

import RidesMembershipList from "../../components/RiderMembershipListing";
import RidesMembershipDetail from "../../components/RiderMembershipDetail";
import RideList from "../../components/RidesListing";
import RideDetail from "../../components/RideDetail";
import RideCreate from "../../components/RideRegistration";

class Rides extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleFetchAllRideMembership = (data) => {
    this.props.actions.fetchAllRidesMembership(data);
  };

  handleFetchSingleRideMembership = (data) => {
    this.props.actions.fetchSingleRideMembership(data);
  };

  handleApproveRideMembership = (data, reqObj) => {
    this.props.actions.approveRideMembership(data, reqObj);
  };

  handleFetchAllRide = () => {
    this.props.actions.fetchAllRide();
  };

  handleFetchSingleRide = (data) => {
    this.props.actions.fetchSingleRide(data);
  };

  handleFetchCountry = (data) => {
    this.props.actions.fetchRideCountry(data);
  };

  handleFetchState = (data) => {
    this.props.actions.fetchRideState(data);
  };

  handleFetchCity = (data) => {
    this.props.actions.fetchRideCity(data);
  };

  handleCreateRide = (data) => {
    this.props.actions.createRide(data);
  };

  handleUpdateRide = (data) => {
    this.props.actions.updateRide(data);
  };

  handleUpdateVin = (data) => {
    this.props.actions.updateVinOfUser(data);
  };

  handleFetchRidesForModeration = (data) => {
    this.props.actions.fetchRidesForModeration(data);
  };

  handleRideModeration = (data, status) => {
    this.props.actions.moderateRides(data, status);
  };

  handleRideGallery = (data) => {
    this.props.actions.rideGallery(data);
  };

  handleUsersForJoinRide = (data) => {
    this.props.actions.fetchUserForJoinRide(data);
  };

  handleUsersModerationForJoinRide = (data) => {
    this.props.actions.moderateUserForRide(data);
  };

  handleFetchAllUser = (data) => {
    this.props.actions.fetchAllUser(data);
  };

  handleJoinUser = (data) => {
    this.props.actions.joinNewUser(data);
  };

  handleExportToExcel = (data) => {
    this.props.actions.exportToExcel(data);
  };

  handleClearPreviousReducer = () => {
    this.props.actions.clearPreviousReducer();
  };

  handleFetchImagesForModeration = () => {
    this.props.actions.fetchImagesForModeration();
  };

  handleUpdateRideAdmin = (data) => {
    this.props.actions.updateRideByAdmin(data);
  };

  handleFetchMotorCycle = (data) => {
    this.props.actionsRides.fetchMotorCylce(data);
  };

  handleVechicleOnboarding = (data) => {
    this.props.actionsRides.vechicleOnBoard(data);
  };

  handlePendingVehicleOnboarding = (data, vehicleId) => {
    this.props.actionsRides.pendingVehicleOnBoard(data, vehicleId);
  };

  handleFetchUserVehicles = (data) => {
    this.props.actionsRides.fetchUserVehicles(data);
  };

  handleVehicleOnBoardingFromMemberShip = (data) => {
    this.props.actionsRides.vechicleOnBoardFromMemberShip(data);
  };

  render() {
    let { page } = this.props.match.params;
    switch (page) {
      case "member-list":
        return (
          <RidesMembershipList
            handleFetchAllRideMembership={this.handleFetchAllRideMembership}
            handleClearPreviousReducer={this.handleClearPreviousReducer}
            handleExportToExcel={this.handleExportToExcel}
            ridesMembershipStatus={this.props.ridesMembershipStatus}
            ridesMembership={this.props.ridesMembership}
            ridesMembershipCount={this.props.ridesMembershipCount}
            exportToExcelStatus={this.props.exportToExcelStatus}
            query={this.props.location.search}
            elements={this.props.elements}
            handleFetchSingleRideMembership={
              this.handleFetchSingleRideMembership
            }
            handleApproveRideMembership={this.handleApproveRideMembership}
            handleUpdateVin={this.handleUpdateVin}
            singleRidesMembershipStatus={this.props.singleRidesMembershipStatus}
            singleRidesMembership={this.props.singleRidesMembership}
            approvingRidesMembershipStatus={
              this.props.approvingRidesMembershipStatus
            }
            consentFormStatus={this.props.consentFormStatus}
            consentForm={this.props.consentForm}
            motorCycleStatus={this.props.motorCycleStatus}
            motorCycle={this.props.motorCycle}
            motorCycleCountryStatus={this.props.motorCycleCountryStatus}
            motorCycleCountry={this.props.motorCycleCountry}
            handleFetchMotorCycle={this.handleFetchMotorCycle}
            handleVechicleOnboarding={this.handleVechicleOnboarding}
            handlePendingVehicleOnboarding={this.handlePendingVehicleOnboarding}
            handleFetchUserVehicles={this.handleFetchUserVehicles}
            vechicleOnboardingStatus={this.props.vechicleOnboardingStatus}
            userVehicles={this.props.userVehicles}
            userVehiclesStatus={this.props.userVehiclesStatus}
            handleVehicleOnBoardingFromMemberShip={
              this.handleVehicleOnBoardingFromMemberShip
            }
            handleRideModeration={this.handleRideModeration}

            // handleFetchSingleRideMembership={
            //   this.handleFetchSingleRideMembership
            // }
            // handleApproveRideMembership={this.handleApproveRideMembership}
            // handleUpdateVin={this.handleUpdateVin}
            // singleRidesMembershipStatus={this.props.singleRidesMembershipStatus}
            // singleRidesMembership={this.props.singleRidesMembership}
            // approvingRidesMembershipStatus={
            //   this.props.approvingRidesMembershipStatus
            // }
            // consentFormStatus={this.props.consentFormStatus}
            // consentForm={this.props.consentForm}
            // elements={this.props.elements}
            // motorCycleStatus={this.props.motorCycleStatus}
            // motorCycle={this.props.motorCycle}
            // motorCycleCountryStatus={this.props.motorCycleCountryStatus}
            // motorCycleCountry={this.props.motorCycleCountry}
            // handleFetchMotorCycle={this.handleFetchMotorCycle}
            // handleVechicleOnboarding={this.handleVechicleOnboarding}
            // handlePendingVehicleOnboarding={this.handlePendingVehicleOnboarding}
            // handleFetchUserVehicles={this.handleFetchUserVehicles}
            // vechicleOnboardingStatus={this.props.vechicleOnboardingStatus}
            // userVehicles={this.props.userVehicles}
            // userVehiclesStatus={this.props.userVehiclesStatus}
            // handleVehicleOnBoardingFromMemberShip={
            //   this.handleVehicleOnBoardingFromMemberShip
            // }
          />
        );

      case "member-detail":
        return (
          <RidesMembershipDetail
            query={this.props.location.search}
            handleFetchSingleRideMembership={
              this.handleFetchSingleRideMembership
            }
            handleApproveRideMembership={this.handleApproveRideMembership}
            handleUpdateVin={this.handleUpdateVin}
            singleRidesMembershipStatus={this.props.singleRidesMembershipStatus}
            singleRidesMembership={this.props.singleRidesMembership}
            approvingRidesMembershipStatus={
              this.props.approvingRidesMembershipStatus
            }
            consentFormStatus={this.props.consentFormStatus}
            consentForm={this.props.consentForm}
            elements={this.props.elements}
            motorCycleStatus={this.props.motorCycleStatus}
            motorCycle={this.props.motorCycle}
            motorCycleCountryStatus={this.props.motorCycleCountryStatus}
            motorCycleCountry={this.props.motorCycleCountry}
            handleFetchMotorCycle={this.handleFetchMotorCycle}
            handleVechicleOnboarding={this.handleVechicleOnboarding}
            handlePendingVehicleOnboarding={this.handlePendingVehicleOnboarding}
            handleFetchUserVehicles={this.handleFetchUserVehicles}
            vechicleOnboardingStatus={this.props.vechicleOnboardingStatus}
            userVehicles={this.props.userVehicles}
            userVehiclesStatus={this.props.userVehiclesStatus}
            handleVehicleOnBoardingFromMemberShip={
              this.handleVehicleOnBoardingFromMemberShip
            }
            handleRideModeration={this.handleRideModeration}
          />
        );

      case "list":
        return (
          <RideList
            page={page}
            allRides={this.props.allRides}
            allRidesStatus={this.props.allRidesStatus}
            handleFetchAllRide={this.handleFetchAllRide}
            handleFetchSingleRide={this.handleFetchSingleRide}
            elements={this.props.elements}
            singleRide={this.props.singleRide}
            singleRideStatus={this.props.singleRideStatus}
            query={this.props.location.search}
            handleUsersForJoinRide={this.handleUsersForJoinRide}
            handleUsersModerationForJoinRide={
              this.handleUsersModerationForJoinRide
            }
            handleJoinUser={this.handleJoinUser}
            handleFetchAllUser={this.handleFetchAllUser}
            handleClearPreviousReducer={this.handleClearPreviousReducer}
            handleFetchImagesForModeration={this.handleFetchImagesForModeration}
            handleRideGallery={this.handleRideGallery}
            handleRideModeration={this.handleRideModeration}
            allUserStatus={this.props.allUserStatus}
            allUser={this.props.allUser}
            usersToJoinRideStatus={this.props.usersToJoinRideStatus}
            usersToJoinRide={this.props.usersToJoinRide}
            moderationStatusForUser={this.props.moderationStatusForUser}
            moderateRideGalleyStatus={this.props.moderateRideGalleyStatus}
          />
        );

      case "create":
        return (
          <RideCreate
            page={page}
            countries={this.props.countries}
            states={this.props.states}
            cities={this.props.cities}
            createRideStatus={this.props.createRideStatus}
            query={this.props.location.search}
            handleFetchCountry={this.handleFetchCountry}
            handleFetchState={this.handleFetchState}
            handleFetchCity={this.handleFetchCity}
            handleCreateRide={this.handleCreateRide}
            handleUpdateRide={this.handleUpdateRide}
            handleRideModeration={this.handleRideModeration}
            elements={this.props.elements}
          />
        );

      case "update":
        return (
          <RideCreate
            page={page}
            singleRide={this.props.singleRide}
            singleRideStatus={this.props.singleRideStatus}
            countries={this.props.countries}
            states={this.props.states}
            cities={this.props.cities}
            updateRideStatus={this.props.updateRideStatus}
            query={this.props.location.search}
            handleFetchCountry={this.handleFetchCountry}
            handleFetchState={this.handleFetchState}
            handleFetchCity={this.handleFetchCity}
            handleCreateRide={this.handleCreateRide}
            handleUpdateRide={this.handleUpdateRide}
            handleFetchSingleRide={this.handleFetchSingleRide}
            handleRideModeration={this.handleRideModeration}
            elements={this.props.elements}
          />
        );

      case "ride-update":
        return (
          <RideCreate
            page={page}
            singleRide={this.props.singleRide}
            singleRideStatus={this.props.singleRideStatus}
            countries={this.props.countries}
            states={this.props.states}
            cities={this.props.cities}
            updateRideStatus={this.props.updateRideStatus}
            query={this.props.location.search}
            handleFetchCountry={this.handleFetchCountry}
            handleFetchState={this.handleFetchState}
            handleFetchCity={this.handleFetchCity}
            handleUpdateRideAdmin={this.handleUpdateRideAdmin}
            handleCreateRide={this.handleCreateRide}
            handleUpdateRide={this.handleUpdateRide}
            handleFetchSingleRide={this.handleFetchSingleRide}
            handleRideModeration={this.handleRideModeration}
            elements={this.props.elements}
          />
        );

      case "detail":
        return (
          <RideDetail
            page={page}
            singleRide={this.props.singleRide}
            singleRideStatus={this.props.singleRideStatus}
            query={this.props.location.search}
            handleFetchSingleRide={this.handleFetchSingleRide}
            handleUsersForJoinRide={this.handleUsersForJoinRide}
            handleUsersModerationForJoinRide={
              this.handleUsersModerationForJoinRide
            }
            handleRideModeration={this.handleRideModeration}
            handleJoinUser={this.handleJoinUser}
            handleFetchAllUser={this.handleFetchAllUser}
            handleClearPreviousReducer={this.handleClearPreviousReducer}
            handleFetchImagesForModeration={this.handleFetchImagesForModeration}
            handleRideGallery={this.handleRideGallery}
            elements={this.props.elements}
            allUserStatus={this.props.allUserStatus}
            allUser={this.props.allUser}
            usersToJoinRideStatus={this.props.usersToJoinRideStatus}
            usersToJoinRide={this.props.usersToJoinRide}
            moderationStatusForUser={this.props.moderationStatusForUser}
            moderateRideGalleyStatus={this.props.moderateRideGalleyStatus}
          />
        );
      case "moderation":
        return (
          <RideList
            page={page}
            allRides={this.props.allRides}
            allRidesStatus={this.props.allRidesStatus}
            ridesForModerationStatus={this.props.ridesForModerationStatus}
            ridesForModeration={this.props.ridesForModeration}
            handleFetchRidesForModeration={this.handleFetchRidesForModeration}
            handleFetchSingleRide={this.handleFetchSingleRide}
            elements={this.props.elements}
            singleRide={this.props.singleRide}
            singleRideStatus={this.props.singleRideStatus}
            query={this.props.location.search}
            handleUsersForJoinRide={this.handleUsersForJoinRide}
            handleUsersModerationForJoinRide={
              this.handleUsersModerationForJoinRide
            }
            handleRideModeration={this.handleRideModeration}
            handleJoinUser={this.handleJoinUser}
            handleFetchAllUser={this.handleFetchAllUser}
            handleClearPreviousReducer={this.handleClearPreviousReducer}
            handleFetchImagesForModeration={this.handleFetchImagesForModeration}
            handleRideGallery={this.handleRideGallery}
            allUserStatus={this.props.allUserStatus}
            allUser={this.props.allUser}
            usersToJoinRideStatus={this.props.usersToJoinRideStatus}
            usersToJoinRide={this.props.usersToJoinRide}
            moderationStatusForUser={this.props.moderationStatusForUser}
            moderateRideGalleyStatus={this.props.moderateRideGalleyStatus}
          />
        );

      case "moderation-detail":
        return (
          <RideDetail
            page={page}
            singleRide={this.props.singleRide}
            singleRideStatus={this.props.singleRideStatus}
            query={this.props.location.search}
            moderateRidesStatus={this.props.moderateRidesStatus}
            handleFetchSingleRide={this.handleFetchSingleRide}
            handleRideModeration={this.handleRideModeration}
            handleRideGallery={this.handleRideGallery}
            handleClearPreviousReducer={this.handleClearPreviousReducer}
            elements={this.props.elements}
            handleUsersForJoinRide={this.handleUsersForJoinRide}
            handleUsersModerationForJoinRide={
              this.handleUsersModerationForJoinRide
            }
            handleJoinUser={this.handleJoinUser}
            handleFetchAllUser={this.handleFetchAllUser}
            allUserStatus={this.props.allUserStatus}
            allUser={this.props.allUser}
            usersToJoinRideStatus={this.props.usersToJoinRideStatus}
            usersToJoinRide={this.props.usersToJoinRide}
            moderationStatusForUser={this.props.moderationStatusForUser}
            moderateRideGalleyStatus={this.props.moderateRideGalleyStatus}
          />
        );
      default:
        return null;
    }
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(sessionActions, dispatch),
    actionsRides: bindActionCreators(sessionActionss, dispatch),
  };
}

function mapStateToProps(state) {
  return {
    allUserStatus: state.Ride.allUserStatus,
    allUser: state.Ride.allUser,
    ridesMembershipStatus: state.Ride.ridesMembershipStatus,
    ridesMembership: state.Ride.ridesMembership,
    ridesMembershipCount: state.Ride.ridesMembershipCount,
    singleRidesMembershipStatus: state.Ride.singleRidesMembershipStatus,
    singleRidesMembership: state.Ride.singleRidesMembership,
    approvingRidesMembershipStatus: state.Ride.approvingRidesMembershipStatus,
    consentFormStatus: state.Ride.consentFormStatus,
    consentForm: state.Ride.consentForm,
    countryStatus: state.Ride.countryStatus,
    countries: state.Global.countries,
    stateStatus: state.Ride.stateStatus,
    states: state.Ride.states,
    cityStatus: state.Ride.cityStatus,
    cities: state.Ride.cities,
    allRides: state.Ride.allRides,
    allRidesStatus: state.Ride.allRidesStatus,
    singleRide: state.Ride.singleRide,
    singleRideStatus: state.Ride.singleRideStatus,
    createRideStatus: state.Ride.createRideStatus,
    updateRideStatus: state.Ride.updateRideStatus,
    moderateRidesStatus: state.Ride.moderateRidesStatus,
    ridesForModerationStatus: state.Ride.ridesForModerationStatus,
    ridesForModeration: state.Ride.ridesForModeration,
    usersToJoinRideStatus: state.Ride.usersToJoinRideStatus,
    usersToJoinRide: state.Ride.usersToJoinRide,
    moderationStatusForUser: state.Ride.moderationStatusForUser,
    exportToExcelStatus: state.Ride.exportToExcelStatus,
    elements: state.Elements.elements,
    motorCycleStatus: state.User.motorCycleStatus,
    motorCycle: state.User.motorCycle,
    motorCycleCountryStatus: state.User.motorCycleCountryStatus,
    motorCycleCountry: state.Global.countries,
    vechicleOnboardingStatus: state.User.vechicleOnboardingStatus,
    userVehicles: state.User.userVehicles,
    userVehiclesStatus: state.User.userVehiclesStatus,
    moderateRideGalleyStatus: state.Ride.moderateRideGalleyStatus,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Rides));
